import { RaidSeasonViewer } from '../shared/RaidSeasonViewer.jsx';

export function DesktopRaidSeason() {
  return <RaidSeasonViewer />;
}
